exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'cat';\n  src: url(\"/assets/fonts/cat.eot?vcfb5d\");\n  src: url(\"/assets/fonts/cat.eot?vcfb5d#iefix\") format(\"embedded-opentype\"), url(\"/assets/fonts/cat.ttf?vcfb5d\") format(\"truetype\"), url(\"/assets/fonts/cat.woff?vcfb5d\") format(\"woff\"), url(\"/assets/fonts/cat.svg?vcfb5d#cat\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n:host .defaultValue {\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-size: 10px;\n  line-height: 11px;\n  margin-top: 0;\n  margin-right: 0;\n  margin-bottom: 0;\n  margin-left: 0;\n  padding-top: 0.5rem;\n  font-style: italic;\n  padding-left: 1.5rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-device/components/input-icon-pos/input-icon-pos.component.scss
// module id = ../../../../../src/app/modules/models/ggw-device/components/input-icon-pos/input-icon-pos.component.scss
// module chunks = main